export const createStoreHook = (useStore) => (selector) => {
    return () => useStore(selector);
};
